export const config = {
	URL: "https://bo.babycourse.ru/api/v1",
};

export const option = {
	Authorization: "",
};
